import React, { useContext, useMemo } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import AuthContext from "../AuthContext";

type PrivateRouteProps = {
    login: React.ReactNode;
    children?: React.ReactNode;
    admin?: boolean;
};

export default function PrivateRoute({ login, admin, children, ...props }: PrivateRouteProps & RouteProps) {
    const authState = useContext(AuthContext);
    const accessTokenOverride = useMemo(() => {
        let params = new URLSearchParams(window.location.search);
        if (params.has("accessToken")) {
            return params.get("accessToken")!;
        } else {
            return undefined;
        }
    }, [window.location.search]);

    return (
        <Route {...props}>
            {authState.auth || accessTokenOverride ? (
                admin && (accessTokenOverride || !authState.auth?.user.admin) ? (
                    <Redirect to="/" />
                ) : (
                    children
                )
            ) : (
                login
            )}
        </Route>
    );
}
